// @flow
import deepEqual from 'react-fast-compare';
import { arrToObject, mapValues } from 'utils/functional';
import { EMPTY_SEARCH_LOCATION } from 'utils/constants';

type Level = $ReadOnly<{ id: string, name: string }>;

export const levelOptions = (levels: $ReadOnlyArray<Level>): Array<string> =>
  levels.map(level => level.id);

export const levelOptionTitles = (
  levels: $ReadOnlyArray<Level>
): { [string]: string } => arrToObject(levels.map(l => [l.id, l.name]));

export const toSemanticFilter = ({
  startName,
  startValue,
  endName,
  endValue
}: {
  startName: string,
  startValue: ?(number | string | boolean),
  endName: string,
  endValue: ?(number | string | boolean)
}) => {
  const startEnd = {
    starts: {
      filterType: 'semantic',
      name: endName,
      operator: '>',
      value: startValue
    },
    ends: {
      filterType: 'semantic',
      name: startName,
      operator: '<',
      value: endValue ? Number(endValue) : null
    }
  };
  return mapValues(startEnd, v => (v.value ? v : null));
};

export const isLocationEmpty = (s: ?SearchLocation) =>
  !s || deepEqual(EMPTY_SEARCH_LOCATION, s);
